module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e42"
    }
  }, [_vm._v("OTHER BOOKS BY ACE COLLINS")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e44"
    }
  }, [_c('i', [_vm._v("Turn Your Radio On: The Stories Behind Gospel Music’s All-Time"), _c('br'), _vm._v(" Greatest Songs")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e49"
    }
  }, [_c('i', [_vm._v("Stories Behind the Best-Loved Songs of Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e52"
    }
  }, [_c('i', [_vm._v("Stories Behind the Great Traditions of Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e55"
    }
  }, [_c('i', [_vm._v("Stories Behind the Hymns That Inspire America")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecc9b7e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coll_ISBN0310862558_epub_c2_r1.vue
// module id = 60
// module chunks = 0